// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","iframe":"ClassicUITabAdapter__iframe--d4","loading":"ClassicUITabAdapter__loading--Wy"};